<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong><i class="cui-graph icons font-2xl mt-4"></i> Master AWB Details  </strong>
            <div class="card-header-actions">       
              <router-link
        to="/masterawblisting"
      > <button class="btn btn-sm btn-primary mr-4 btn-pill"   type="button">MasterAwbListing</button> </router-link>                  
            </div>
          </div>  
           <div class="card-body">
             <div class="row mb-12">
              <!-- msaterawbdetails barcode -->
              <div class="col-sm-12 text-right">
                      <!-- <img  src="img/B.jpg"  style="width:120px; height:40px;" /> -->
           <!--  <div id="printableArea" >
            <div class="page-break" v-for="item in details"  >
              <table>
                  <tr >
                    <td >
                     <div>
                      <table border = '1' class="stickertable"  >
                        <tr>

                          <td>
                          <div style='text-align: center;font-size: 2px;'>
                          <img id='test'/>
                          <div id="app" >
                                  {{item.master_awb}}
                          <barcode v-bind:value="item.master_awb">
                          Show this if the rendering fails.
                          </barcode>
                          </div>
                          </div>
                          </td>
                        </tr>
                     </table>
                   </div>
                    </td>
                  </tr>
                </table>
            </div>           
          </div> -->
         <div id="app">
  <!-- <input style="display:none" v-model="barcodeValue" /><br> -->
  <barcode v-bind:value="barcodeValue" font-options="bold" >
    Can't generate the barcode
  </barcode>
</div>   <!-- <img id='test'/>
                          <div id="app" >
                                  {{item.master_awb}}
                          <barcode v-bind:value="item.master_awb">
                          Show this if the rendering fails.
                          </barcode>
                          </div> -->

                </div>
             </div>
             <br>
            <div class="row mb-12">
               
                 <div class="col-sm-2">
                      <strong>Master AWB</strong>
                </div>
                <div class="col-sm-1">:</div>
                <div class="col-sm-3">
                      {{details.master_awb}}
                </div>
                <div class="col-sm-2">
                      <strong>Status</strong>
                </div>
                <div class="col-sm-1">:</div>
                <div class="col-sm-3">
                       {{details.status}} 
                </div>
            </div>
            <br>
            <div class="row mb-12">
               
                 <div class="col-sm-2">
                      <strong>Consolidated Invoice</strong>
                </div>
                <div class="col-sm-1">:</div>
                <div class="col-sm-3">
                     {{details.consolidate_invoiceno}} 
                </div>
                <div class="col-sm-2">
                      <strong>G.P NO</strong>
                </div>
                <div class="col-sm-1">:</div>
                <div class="col-sm-3">
                        {{details.gp_no}} 
                </div>
            </div>
            <br>
            <div class="row mb-12">
               
                 <div class="col-sm-2">
                      <strong>Created Date</strong>
                </div>
                <div class="col-sm-1">:</div>
                <div class="col-sm-3">
                      {{details.invoice_generated_date}} 
                </div>

                <div class="col-sm-2" v-if="details.status=='MasterAwb Created'">
                      <strong>Submit Master AWB</strong>
                </div>
                <div class="col-sm-1" v-if="details.status=='MasterAwb Created'">:</div>
                <div class="col-sm-3" v-if="details.status=='MasterAwb Created'">
                        <b-form-select  id="dhl_mode" name="dhl_mode" placeholder="Please Select Mode Of DHL" v-model="dhl_mode" @change="changedhlmode(dhl_mode)">
                        <option value="">--Select--</option>
                        <option  value="0">Via DHL</option>
                        <option  value="3">Via Sky EX</option>
                    </b-form-select>
                </div>


                
            </div>
            <hr>
            <br>
            <div class="row md-12"> 
            <b-col md="12">
               <b-col md="12">
            <b-table show-empty  hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="reverseitem" :bordered="bordered" :fields="reversefield" caption-top>
              <template slot="table-caption"><b>Shipments</b></template>
          </b-table>
        </b-col>
          </b-col>
          </div>
            <!-- <div class="row mb-12">
             
                <strong>Shipments:</strong>
            </div>
            <br>
            <div class="row mb-12" >
              <tr style="display: contents;">
                  <td class="field-value" v-for="pincode in shippinglist" style="border: 1px solid #7f8c8d;">
                        {{pincode.shippingid}}
                      </td>
                    </tr>
            </div> -->
            <hr>
            <br>
            <div class="row mb-12">
               <div class="col-sm-12">
                <strong>DHL Details</strong>
              </div>
            </div>
           

          <!--  <b-table show-empty stacked="md"   :items="shippinglist1"  :fields="fields"   :bordered="bordered">

              <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
               
                 <template slot="receiptpdf" slot-scope="row">
                  <div>
                    Download
                   <a :href="receipturl" target="_blank"><i class="fa fa-download"
                      aria-hidden="true" style="color: #0275d8; margin-left: 5px;">&nbsp;</i></a>
                       </div>
                 </template>
                  <template slot="invoicepdf" slot-scope="row">
                    <div>
                    Download
                   <a :href="invoiceurl" target="_blank"><i class="fa fa-download"
                      aria-hidden="true" style="color: #0275d8; margin-left: 5px;">&nbsp;</i></a>
                       </div>
                 </template>
                  <template slot="lablepdf" slot-scope="row">
                     <div>
                    Download
                   <a :href="lableurl" target="_blank"><i class="fa fa-download"
                      aria-hidden="true" style="color: #0275d8; margin-left: 5px;">&nbsp;</i></a>
                       </div>
                 </template>


           </b-table> -->

             <div class="row mb-12"> 
              <table class="table table-striped"  >
                 <thead>
                  <tr>
                    <th scope="col" style="border: 1px solid #c8ced3;">Master AWB</th>
                     <th scope="col" style="border: 1px solid #c8ced3;">Tracking Number</th>
                    <th scope="col" style="border: 1px solid #c8ced3;">DispatchDate</th>
                    <th scope="col" style="border: 1px solid #c8ced3;">Receipt</th>
                    <th scope="col" style="border: 1px solid #c8ced3;">Invoice</th>
                    <th scope="col" style="border: 1px solid #c8ced3;">Label</th>
                    <th scope="col" style="border: 1px solid #c8ced3;">Action</th>
                  </tr>
                </thead>
                 <tbody>
                  <td style="border: 1px solid #c8ced3;">{{details.master_awb}}</td>
                  <td style="border: 1px solid #c8ced3;" v-if="details.shipmenttrackingnumber!='undefined'">{{details.shipmenttrackingnumber}}</td>
                  <td style="border: 1px solid #c8ced3;">{{details.dispatch_date}}</td>
                  <td style="border: 1px solid #c8ced3;">
                    <div v-if="receipturl!=''">
                    Download
                   <a :href="receipturl" target="_blank"><i class="fa fa-download"
                      aria-hidden="true" data-toggle="tooltip" title="Receipt PDF" style="color: #333; margin-left: 5px;">&nbsp;</i></a>
                       </div>
                  </td>
                   <td style="border: 1px solid #c8ced3;">
                    <div v-if="invoiceurl!=''">
                    Download
                   <a :href="invoiceurl" target="_blank"><i class="fa fa-download"
                      aria-hidden="true" data-toggle="tooltip" title="Invoice PDF" style="color: #333; margin-left: 5px;">&nbsp;</i></a>
                       </div>
                  </td>
                   <td style="border: 1px solid #c8ced3;">
                      <div v-if="lableurl!=''">
                    Download
                   <a :href="lableurl" target="_blank"><i class="fa fa-download"
                      aria-hidden="true" data-toggle="tooltip" title="Label PDF" style="color: #333; margin-left: 5px;">&nbsp;</i></a>
                       </div>
                  </td>
                  <td style="border: 1px solid #c8ced3;"></td>
                 </tbody>
              </table>
             </div>










            </div>        
        </b-card>
      </b-col>
    </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import VueBarcode from 'vue-barcode';
export default {
  data: function () {
    return {
       isBusy: false, 
       barcodeValue: '',
      value:[],
      // items:[],
      // masterawbdata:[],
      details:[],
      shippinglist1:[],
      shippinglist:[],
      master:'',
      checkedData: false,
      bordered: true,
        totalRows: 0,
        receipturl:'',
        invoiceurl:'',
        dhl_mode:'',
        lableurl:'',
        reversefield:[
        {key:'shippingid' , label:'Shipping Id' },
       {key:'orderid' , label: 'Order ID'},
         {key:'shipmentstatus' , label: 'Shipment Status'},
          {key:'deliverystatus' , label: 'Delivery Status'},
           {key:'created_date' , label: 'Created Date'},
           {key:'lastmodifieddate' , label: 'Modified Date'},
          
            {key:'pickuptype' , label: 'Pickup Type'},
             {key:'countrycode' , label: 'Country' },
        {key:'modeoftransport' , label: 'ModeOf Transport'},
        {key:'servicetype' , label: 'Service Type' },
        ],
        reverseitem:[],
        // currentPage: 1,
        //perPage:  10,
        // pageOptions: [5, 10, 15],
        // sortBy: null,
        // sortDesc: true,
        // sortDirection: 'desc',
        // filter: null,
     // pickup_pincode:[100002,100003,100004,100005,100002,100003,100004,100005,100002,100003,100004,100005,100002,100003,100004,100005,100002,100003,100004,100005],
      // items: [
      //     { Master_AWB:'BHR_ROAD_2021-04-02_1' , Submitted_Date: '2021-04-01', Receipt_No: '3456', Action:''},
      //     // { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
      //     // { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
      //     // { age: 38, first_name: 'Jami', last_name: 'Carney' }
      //   ],
        // fields:[
        //     {  key: "master_awb",label: 'Master AWB' },
        //     {  key: "dispatch_date",label: 'DispatchDate'},
        //     {  key: "receiptpdf",label: 'Receipt'},
        //     {key: 'invoicepdf', label: 'Invoice'},
        //      {key: 'lablepdf', label: 'Label'},
        //    {  key: "actions",label: 'Action' }
        // ]
    }
  },
   components: {
    'barcode': VueBarcode
  },
  created: function () {
    // alert('created');
    this.getawbdetails();
    this.getawbshipmentlist();
  },
  methods: {

  changedhlmode: function(mode){
    var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    var Obj={
        master_awb:this.$route.params.id,
        hub_id:`${userInfo.pickuplocationmasterid}`,
        submit_via: mode,
        created_by:`${userInfo.sysemailid}`,
      }

      
      if(mode!= ''){
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/pushdatatodhlmanually`,Obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             alert(result.body.returnvalue);
             this.getawbdetails();
             this.getawbshipmentlist();
          } 
          else {
            alert(result.body.returnvalue);
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      }

  },
   
  getawbdetails:function(){
    // alert("in");
      this.isBusy = true;
    var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //  var Obj = {
      //     // pallet_id : value.pallet_id,
      //    // linehaulpallet_id: value.pallet_id,
      //   // master_awb:value.master_awb,
      //   deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
      //   hub_id:`${userInfo.pickuplocationmasterid}`,
         
            
      
      // };  
      var Obj={
        master_awb:this.$route.params.id,
        hub_id:`${userInfo.pickuplocationmasterid}`,
      }


      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmasterawbdetails`,Obj)
        .then((result) => {
          // console.log("jjjjjjjj",result);
          if (result.body.returnmsg === 'Successful') {
             
          // this.isBusy = !this.isBusy
              // console.log("UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU",result.body.returnvalue.master_awb_details[0].invoicepdfurl)
               this.details  = result.body.returnvalue.master_awb_details[0];
               // this.masterawbdata=result.body.returnvalue;
           // console.log('masterawbdata',this.details);
           this.barcodeValue=result.body.returnvalue.master_awb_details[0].master_awb;
           console.log("barcode",this.barcodeValue);
           this.shippinglist=result.body.returnvalue.shipment_list;
           // console.log('masterawbdata',this.shippinglist);
           //    this.awblist=result.body.returnvalue.shipment_list;
              // console.log("shippinglist",this.shippinglist);
              // this.editAgentMaster = true;
              this.shippinglist1=result.body.returnvalue.shipment_list,
              // console.log("shippinglist",this.shippinglist1);
              this.receipturl=result.body.returnvalue.master_awb_details[0].receiptpdfurl;
              this.invoiceurl=result.body.returnvalue.master_awb_details[0].invoicepdfurl;
              this.lableurl=result.body.returnvalue.master_awb_details[0].lablepdfurl;

              // console.log("jjjjjjjj",this.lableurl);
          } 
          else {
            // this.isBusy = !this.isBusy
            this.details=[];
             this.shippinglist=[];
          // this.awblist=result.body.returnvalue;
          // this.editAgentMaster = true;  
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })

},

getawbshipmentlist:function(){
    // alert("in");
      this.isBusy = true;
    var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
      var revobj={
        master_awb:this.$route.params.id,
        // hub_id:`${userInfo.pickuplocationmasterid}`,
      }


       this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getshipmentlistofmasterawb`,revobj)
       .then((result) => {
          // console.log("jjjjjjjj",result);
          if (result.body.returnmsg === 'Successful') {
               this.reverseitem = result.body.returnvalue;
                this.isBusy =false
       
          } 
          else {
           this.reverseitem=[];
           this.isBusy = false

          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })

},



// barcode
setStickerHTMl(e,value){
           this.details=[];
          // alert("i m in setstiker")
          // alert(this.checkedData);
      // this.qrvalue="";
         this.checkedData=true;
    
 const obj = {

        master_awb:this.$route.params.id,
        // country:value.country,
        // transport_mode:value.transport_mode

       

      }

           this.masterawbdataarr.push(obj);
    
    },

  



     
   
  },

 
};
</script>
<style type="text/css">
  .b-table-caption-top{
    color: black;
  }
/*.table button {
    background: #f6f7f9!important;
    color: white!important;
    border: none;
}*/


  .shipping table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  padding: 5px;
  text-align: left;    
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  /*display: none;*/ /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
.vue-barcode-element{
  width:270px;
  height:110px;
}
</style>
